import { Submenu } from '../../../Register/RegisterSitemap'

export const mappingSubmenu = (index: any, active: any) => {
    if (active === '') {
        active = window.location.pathname
    }
    return Submenu(index, active)
}
